import React from "react";
import { Alert } from "antd";
import DangerSVG from "@images/funds/danger.svg";

const BftNotice = () => (
  <Alert
    showIcon
    icon={<DangerSVG />}
    description={
      <>
        <b>
          NOTE: Any BFT you received as a bonus for verifying and certifying
          your account cannot be withdrawn unless you have made a minimum of
          $100k investment on the BF Platform.
        </b>
        <br />
        <br />
        Please refer to the full
        <a
          target="_blank"
          href={`${process.env.WORDPRESS_DOMAIN}/terms-conditions`}
        >
          {" "}
          terms and conditions
        </a>
        . If you do not meet the eligible investment threshold, please only
        withdraw your net amount of BFT (usually without the total of 5,000
        bonus BFT).
        <br />
        BFT rewards can always be used to pay discounted fees on the secondary
        market.
      </>
    }
  />
);

export default BftNotice;
